import { useCallback, useState } from "react";
import { TSituacaoFinanceira } from "../../../../../types/api/financeiro/situacao-financeira";
import DialogCriacaoEditSituacoes from "./DialogCriacaoEditSituacoes";
import SessaoConfiguracao, { ConfiguracaoColunas } from "../../../../../components/BasicComponents/DisplayDados/SessaoConfiguracao";

export default function Situacoes() {

    const [openModal, setOpenModal] = useState<TOpenModalSituacoesFinanceiras>(null)

    //funções manipuladoras
    const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: TSituacaoFinanceira | null) => {
        if (action === "close") setOpenModal(null)
        if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value })
        if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null })
    }, [])
    //

    return (
        <>
            <SessaoConfiguracao<TSituacaoFinanceira>
                titulo="Situações financeiras"
                endpoints={{
                    listar: "financeiro/contas-receber/pesquisar-situacoes",
                    deletar: "financeiro/configuracoes/excluir-situacao",
                }}
                colunas={colunas}
                queryKey="pesquisar-situacoes"
                onEditar={(situacao) => {
                    handleModalAction("open", situacao.id, situacao)
                }}
                onAdicionar={() => {
                    handleModalAction("open", true, null)
                }}
                mensagemSucessoDeletar="Situação deletada com sucesso!"
                mensagemErroDeletar="Erro ao deletar situação!"
                mensagemSemDados="Nenhuma situação encontrada."
            />

            {
                Boolean(openModal?.open) &&
                <DialogCriacaoEditSituacoes
                    defaultValue={openModal?.defaultValue ? openModal : null}
                    open={Boolean(openModal?.open)}
                    handleClose={() => handleModalAction("close")}
                />
            }

        </>
    )
}

export type TOpenModalSituacoesFinanceiras = {
    open: number | boolean | null;
    defaultValue: TSituacaoFinanceira | null;
} | null

const colunas: ConfiguracaoColunas<TSituacaoFinanceira>[] = [
    {
        campo: "id",
        titulo: "Código",
    },
    {
        campo: "nome",
        titulo: "nome",
    },
];

